"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityManager = void 0;
const VisibilityManager = ({ children, hideOn, currentValue }) => {
    if (!hideOn) {
        return children;
    }
    if (hideOn.includes(currentValue)) {
        return null;
    }
    return children;
};
exports.VisibilityManager = VisibilityManager;
//# sourceMappingURL=visibilityManager.js.map